// Generated from src/img/svg/eye.svg

export const Eye = (props) => {
  return (
    <svg height="16" viewBox="0 0 23.467 16" width="23.467" {...props}>
      <path
        d="M13.233 6.75a12.615 12.615 0 0 0-11.733 8 12.6 12.6 0 0 0 23.467 0 12.615 12.615 0 0 0-11.734-8m0 13.333a5.333 5.333 0 1 1 5.333-5.333 5.335 5.335 0 0 1-5.333 5.333m0-8.533a3.2 3.2 0 1 0 3.2 3.2 3.2 3.2 0 0 0-3.2-3.2"
        style={{ fill: "#a2a2a2" }}
        transform="translate(-1.5 -6.75)"
      />
    </svg>
  );
};
